var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStepDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#75019C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2071 15.2929C27.5976 15.6834 27.5976 16.3166 27.2071 16.7071L19.2071 24.7071C18.8166 25.0976 18.1834 25.0976 17.7929 24.7071L13.7929 20.7071C13.4024 20.3166 13.4024 19.6834 13.7929 19.2929C14.1834 18.9024 14.8166 18.9024 15.2071 19.2929L18.5 22.5858L25.7929 15.2929C26.1834 14.9024 26.8166 14.9024 27.2071 15.2929Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepDone);
export default __webpack_public_path__ + "static/media/StepDone.f5d57e6565649499b451ac0b95a3a74d.svg";
export { ForwardRef as ReactComponent };